module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Trains</h1>\n</div>\n<iframe src=\"apps/trains/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/trains/trains.component.html
// module id = ../../../../../src/app/pages/trains/trains.component.html
// module chunks = main